"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  ",
        "\n  ",
        "\n  fragment ProductListingRow on PlpRow {\n    content {\n      __typename\n      ...ProductWithShades\n      ...PromoBannerFragment\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productListingRow = void 0;
var _fetching = require("@ori/fetching");
var _productBox = require("@ori/product-box");
var _promoBannerFragment = require("./promoBannerFragment");
const productListingRow = exports.productListingRow = (0, _fetching.gql)(_templateObject(), _productBox.PRODUCT_WITH_SHADES_FRAGMENT, _promoBannerFragment.promoBannerFragment);
